import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=721cab9a&scoped=true"
import script from "./Buyer.vue?vue&type=script&lang=js"
export * from "./Buyer.vue?vue&type=script&lang=js"
import style0 from "./Buyer.vue?vue&type=style&index=0&id=721cab9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721cab9a",
  null
  
)

export default component.exports